// extracted by mini-css-extract-plugin
module.exports = {"root":"_2d900","list":"_32cfP"};